<script>
  // UsagePanel — per-tab balance / used / total + refresh.
  import { keysApi } from "../api/client.js";

  let { tab } = $props();

  let refreshing = $state(false);
  let refreshError = $state(null);

  async function refresh() {
    if (tab.isDefault) {
      // .env key — no stored entry to refresh against. Could call /api/usage
      // which uses .env directly. For now show a hint.
      refreshError = "Default key (.env) — usage không track per-tab. Add stored key để track riêng.";
      return;
    }
    refreshing = true;
    refreshError = null;
    try {
      const data = await keysApi.refreshOne(tab.keyId);
      // Server returns {key: {...}} with updated usage snapshot
      const k = data.key;
      tab.usage = {
        balance: k.balance,
        used: k.used,
        total: k.total,
        name: k.name,
        group_name: k.group_name,
        used_pct: k.used_pct,
      };
    } catch (err) {
      refreshError = err.message;
    } finally {
      refreshing = false;
    }
  }
</script>

<div class="panel card">
  <div class="panel-head">
    <h2>Usage cho key "{tab.label}"</h2>
    <button class="link-btn" onclick={refresh} disabled={refreshing}>
      {refreshing ? "Đang refresh..." : "↻ Refresh"}
    </button>
  </div>

  {#if refreshError}
    <div class="error">{refreshError}</div>
  {/if}

  {#if tab.usage}
    <div class="stats">
      <div class="stat">
        <span class="label">Balance còn lại</span>
        <span class="value highlight">${tab.usage.balance?.toFixed(4) ?? "—"}</span>
      </div>
      <div class="stat">
        <span class="label">Đã dùng</span>
        <span class="value">${tab.usage.used?.toFixed(4) ?? "—"}</span>
      </div>
      <div class="stat">
        <span class="label">Tổng allotment</span>
        <span class="value">${tab.usage.total?.toFixed(2) ?? "—"}</span>
      </div>
      <div class="stat">
        <span class="label">% đã dùng</span>
        <span class="value">{tab.usage.used_pct ?? "—"}%</span>
      </div>
    </div>

    {#if tab.usage.used_pct != null}
      <div class="usage-bar">
        <div class="usage-bar-fill" style="width: {Math.min(tab.usage.used_pct, 100)}%"></div>
      </div>
    {/if}

    {#if tab.usage.name || tab.usage.group_name}
      <div class="meta-row">
        {#if tab.usage.name}    <span><strong>Name:</strong> {tab.usage.name}</span>      {/if}
        {#if tab.usage.group_name} <span><strong>Group:</strong> {tab.usage.group_name}</span> {/if}
      </div>
    {/if}
  {:else}
    <p class="muted">Chưa có usage snapshot. Click Refresh để fetch live data.</p>
  {/if}
</div>

<style>
  .panel { display: flex; flex-direction: column; gap: 14px; padding: 18px 20px; }
  .panel-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  h2 { margin: 0; font-size: 1rem; color: var(--text-strong); }

  .stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
  }
  .stat {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 12px 14px;
    background: var(--panel-2);
    border: 1px solid var(--border);
    border-radius: 8px;
  }
  .label {
    font-size: 0.7rem;
    text-transform: uppercase;
    color: var(--muted);
    letter-spacing: 0.04em;
  }
  .value {
    font-size: 1.05rem;
    font-weight: 600;
    color: var(--text-strong);
    font-variant-numeric: tabular-nums;
  }
  .value.highlight { color: #7ddc9d; }

  .usage-bar {
    height: 8px;
    background: var(--panel-2);
    border-radius: 4px;
    overflow: hidden;
  }
  .usage-bar-fill {
    height: 100%;
    background: linear-gradient(to right, var(--accent), #7ddc9d);
    transition: width 0.4s ease-out;
  }

  .meta-row {
    display: flex;
    gap: 18px;
    font-size: 0.82rem;
    color: var(--muted-strong);
    flex-wrap: wrap;
  }

  .error {
    padding: 10px 12px;
    background: rgba(248, 113, 113, 0.08);
    border: 1px solid rgba(248, 113, 113, 0.3);
    border-radius: 6px;
    color: #ff8585;
    font-size: 0.82rem;
  }

  .muted { color: var(--muted); font-size: 0.85rem; margin: 0; }
</style>
